import React, { useState, useEffect } from "react";
import { CardComponent, SelectComponent, TitleComponent,TableComponent, ButtonActionComponent } from "../../components/pages";
import { useGetApiWs } from "../../hooks";
import { api, apiConfig } from "../../util/api";
import HeaderMenu from '../layout/headerMenu';


const Planning = (props) => {

    const urlSurveyPlanning = useGetApiWs('admin', 'entity', 'survey-planning-get');

    const [studies,setStudies] = useState([]);
    const [periods, setPeriods] = useState([]);
    const [categories, setCategories] = useState([]);
    const [cities,setCities] = useState([]);
    const [lbStudy,setLbStudy] = useState(null);
    const [lbPeriods, setLbPeriods] = useState(null);
    const [lbCategories, setLbCategories] = useState(null);
    const [lbCities, setLbCities] = useState(null);
    const [studiesIsLoading, setStudiesIsLoading] = useState(true)
    const [periodsIsLoading, setPeriodsIsLoading] = useState(true)
    const [categoriesIsLoading, setCategoriesIsLoading] = useState(true)
    const [citiesIsLoading, setCitiesIsLoading] = useState(true)

    const [tbHeadings, setTbDataHeadings] = useState([]);
    const [btnExports, setBtnExports] = useState(false);
    const [tbColumns, setTbColumns] = useState([]);
    const [tbData, setTbData] = useState([]);
    const [tbPending, setTbPending] = useState(false);

    const fetchStudies = async () => {
        const ob = {type:'study'};
        const studies = await api().post(urlSurveyPlanning, ob, apiConfig());
        if (studies.status === 200 && studies.data.status === 'success') {
            var options = studies.data.response.map(obj => {
                var rObj = {};
                rObj['value'] = obj.type_id;
                rObj['label'] = obj.code;
                return rObj;
            })
            setStudies(options);
        }
        setStudiesIsLoading(false);
    }

    const fetchPeriods = async (study_type_id) => {
        const ob = {type:'period',study_type_id:study_type_id};
        const periods = await api().post(urlSurveyPlanning, ob, apiConfig());
        if (periods.status === 200 && periods.data.status === 'success') {
            var options = periods.data.response.map(obj => {
                const date = new Date();
                date.setMonth(obj.month-1)
                var rObj = {};
                rObj['value'] = obj.period_id;
                rObj['label'] = date.toLocaleString('es-PE', { month: 'long' }).toUpperCase() + '-'+obj.year;
                return rObj;
            })
            setPeriods(options);
        }
        setPeriodsIsLoading(false);
    }
    const fetchCategories = async (period_id) => {
        const ob = {type:'category',study_type_id:lbStudy.value,period_id:period_id};
        const categories = await api().post(urlSurveyPlanning, ob, apiConfig());
        if (categories.status === 200 && categories.data.status === 'success') {
            var options = categories.data.response.map(obj => {
                
                var rObj = {};
                rObj['value'] = obj.category_id;
                rObj['label'] = obj.name;
                return rObj;
            })
            setCategories(options);
        }
        setCategoriesIsLoading(false);
    }
    const fetchCities = async (period_id) => {
        const ob = {type:'city',study_type_id:lbStudy.value,period_id:period_id};
        const cities = await api().post(urlSurveyPlanning, ob, apiConfig());
        if (cities.status === 200 && cities.data.status === 'success') {
            var options = cities.data.response.map(obj => {                
                var rObj = {};
                rObj['value'] = obj.city_id;
                rObj['label'] = obj.name;
                return rObj;
            })
            setCities(options);
        }
        setCitiesIsLoading(false);
    }

    const fetchPlanning = async () => {
        setTbPending(true);
        const ob = {}
        ob['type'] = 'planning';
        ob['period_id'] = lbPeriods.value;
        ob['study_type_id'] = lbStudy.value;
        ob['category_id'] = (lbCategories==null)?null:`|${lbCategories.value}|`
        ob['city_id'] = (lbCities==null)?null:`|${lbCities.value}|`
        var headers = [];
        const res = await api().post(urlSurveyPlanning, ob, apiConfig());
        if (res.status===200 && res.data.status === 'success') {
            let column = [
                {
                    name:'ENCUESTADOR',
                    selector:row=>row.ENCUESTADOR,
                    sortable: true,
                },
                {
                    name:'EMAIL',
                    selector:row=>row.EMAIL,
                    wrap:true,
                    center:true,
                    sortable: true,
                },
                {
                    name:'CIUDAD',
                    selector:row=>row.CIUDAD,
                    compact:true,
                    sortable: true,
                },
                {
                    name:'DISTRITO',
                    selector:row=>row.DISTRITO,
                    compact:true,
                    sortable: true,
                },
                {
                    name:'CANAL',
                    selector:row=>row.CANAL,
                    sortable: true,
                },
                {
                    name:'PUNTOVENTAID',
                    selector:row=>row.PUNTOVENTAID,
                    compact:true,
                    center:true,
                    sortable: true,
                },
                /* {
                    name:'PUNTO VENTA',
                    selector:row=>row.PUNTOVENTA,
                    center:true
                }, */
                {
                    name:'DIRECCIÓN',
                    selector:row=>row.DIRECCION,
                    sortable: true,
                    wrap:true,
                    grow:2
                },
                {
                    name:'CATEGORÍA',
                    selector:row=>row.CATEGORIA,
                    sortable: true,
                }, 
                {
                    name:'SKUID',
                    selector:row=>row.SKUID,
                    sortable: true,
                },
                {
                    name:'SKU',
                    selector:row=>row.SKU,
                    wrap:true,
                    sortable: true,
                    grow:2
                }
                
            ];
            setTbColumns(column);
            setTbData(res.data.response);
            setTbPending(false);
            /* if (res.data.response.length > 0) {
                const head = res.data.response[0]
                headers = Object.keys(head)
                for (var h in headers) {
                    colum.push({
                        name: headers[h], selector: headers[h], sortable: false, wrap: true
                    })
                }
                setBtnExports(true);
                setTbColumns(colum);
                setTbData(res.data.response);
                setTbPending(false);
            } else {
                setBtnExports(false);
                setTbColumns([]);
                setTbData([]);
                setTbPending(false);
            } */
        }
        console.log(res);
    }

    const StudyChange = (vals)=>{
        setLbStudy(vals);
        if(vals!==null)fetchPeriods(vals.value)
    }
    const PeriodChange = (vals)=>{
        setLbPeriods(vals);
        if(vals!==null){
            fetchCategories(vals.value)
            fetchCities(vals.value)            
        }
    }

    const Filter = () => {
        fetchPlanning();
    }

    useEffect(() => {
        fetchStudies();
    }, [])


    const paginationComponentOptions = { rowsPerPageText: 'Filas por página:', rangeSeparatorText: 'de', noRowsPerPage: false, selectAllRowsItem: true, selectAllRowsItemText: 'Todo' }
    
    return (
        <div>
            <TitleComponent title="Planificación y Relevamiento" />
            <div id='options' className='options'>
                <CardComponent header={null} footer={null}>
                    <div className="bg-white p-2 pb-5">
                        <div className="grid md:grid-cols-4 lg:grid-cols-4 items-center gap-4">
                            <SelectComponent onChange={StudyChange} options={studies} value={lbStudy} isLoading={studiesIsLoading} label="Estudio *" isDisabled={false} />
                            <SelectComponent onChange={PeriodChange} options={periods} value={lbPeriods} isLoading={periodsIsLoading} label="Periodo *" isDisabled={false} />
                            <SelectComponent onChange={vals=>{setLbCategories(vals)}} options={categories} value={lbCategories} isLoading={categoriesIsLoading} label="Categoría" isDisabled={false} />
                            <SelectComponent onChange={vals=>{setLbCities(vals)}} options={cities} value={lbCities} isLoading={citiesIsLoading} label="Ciudad" isDisabled={false} />
                        </div>
                        <div className="mt-2">
                            <ButtonActionComponent name="GENERAR" onClick={Filter} />
                        </div>
                    </div>
                </CardComponent>
            </div>
            <div className="pt-3">
                <CardComponent header={<h4 className="">Planificación y Relevamiento</h4>} footer={null}>
                    <div className="bg-white">
                        <TableComponent
                            keyField="survey_planning_id"
                            columns={tbColumns}
                            headItem={tbHeadings}
                            data={tbData}
                            pending={tbPending}
                            highlightOnHover={true}
                            paginationComponentOptions={paginationComponentOptions}

                            pagination 
                        />
                    </div>
                </CardComponent>
            </div>
        </div>
    )
}

export default Planning